import * as React from 'react';
import { observer } from 'mobx-react';
import { nothing, Maybe, just } from 'maybeasy';
import clsx from 'clsx';
import SearchIcon from '../../../../../Cutesies/SearchIcon';
import { TranslationsContext, translation } from '../../../../../../Translations';
import { valueFor } from '../../../../../../ListFilter';
import InvitationsStore from '../../Store';

interface Props {
  store: InvitationsStore;
}
interface State {
  debouncer: Maybe<ReturnType<typeof setTimeout>>;
}

class Search extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      debouncer: nothing(),
    };
  }

  handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.state.debouncer.do((debouncer) => clearTimeout(debouncer));
    this.props.store.updatingQuery({ key: 'query', value: event.target.value });
    this.setState({ debouncer: just(setTimeout(() => this.triggerLoading(), 1000)) });
  };

  triggerLoading = () => {
    this.setState({ debouncer: nothing() });
    this.props.store.loading(1);
  };

  render() {
    const { store } = this.props;
    return (
      <div className="relative w-1/2 mr-4">
        <span className="absolute inset-y-0 left-0 flex items-center pl-4">
          <SearchIcon className="w-6 h-6" />
        </span>
        <TranslationsContext.Consumer>
          {(ts) => (
            <input
              autoFocus
              placeholder={translation('Search Name or Email')(ts)}
              value={valueFor('query', store.searchParameters)}
              onChange={this.handleSearchChange}
              className={clsx(
                'mt-1 block w-full rounded-md border-1 border-solid',
                'border-gray-300 bg-white pl-10 py-2 text-sm font-medium',
              )}
            />
          )}
        </TranslationsContext.Consumer>
      </div>
    );
  }
}

export default observer(Search);
